<template>
    <div class="container">
        <div class="content">
            <div style="padding-left: 16px;padding-right: 16px;">
                <el-tabs v-model="activeName" @tab-click="handleClick" class="custom-tabs2">
                    <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tags"
                        :key="index"></el-tab-pane>
                </el-tabs>
            </div>
            <div v-if="activeName == '1'" class="main1">
                <div class="panel-block flex">
                    <div class="panel-left">
                        <el-form :inline="true" :model="form" ref="form" class="form satff-form" size="small" label-width="96px"
                            :rules="rules" label-position="right" style="width: 100%;">
                            <div class="panel-item anchor-item" ref="anchor-0">
                                <div class="panel-item-title panel-item-title-1">主要信息</div>
                                <div class="panel-item-content">
                                    
                                        <el-form-item label="姓名" prop="reallyName">
                                            <template #label>姓<span class="space"></span>名</template>
                                            <el-input v-model="form.reallyName" placeholder="请输入" maxlength="8" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="性别" prop="">
                                            <template #label>性<span class="space"></span>别</template>
                                            <el-radio-group v-model="form.sex" class="el-input">
                                                <el-radio label="1">男</el-radio>
                                                <el-radio label="2">女</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item label="登录手机号" prop="phoneNumber" >
                                            <div class="connected-con">
                                                <el-input v-model="form.phoneNumber" class="input" placeholder="请输入" maxlength="11"
                                                clearable show-word-limit></el-input>
                                                <template v-if="form.applicantBaseId == null || form.applicantBaseId == ''">
                                                    <template  v-if="form.phoneNumber != ''">
                                                         <div @click="toRelation" class="icon-btn">关联</div>
                                                    </template>
                                                    <template v-else>
                                                        <div  class="icon-btn dis">关联</div>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <div @click="isConfirm = true" class="icon-btn mini">取消<br>关联</div>
                                                </template>
                                                
                                            </div>
                                            <!-- <div style="display: flex;justify-content:space-between;"
                                                v-if="form.applicantBaseId == null || form.applicantBaseId == ''">
                                                <img src="../../../assets/icon_guanlian.png" @click="toRelation()"
                                                    v-if="form.phoneNumber != ''"
                                                    style="width: 16px;height: 16px;padding-top:8px;padding-right:2px" />
                                                <img src="../../../assets/icon_guanlian.png" v-else
                                                    style="width: 16px;height: 16px;padding-top:8px;padding-right:2px" />
                                                <div @click="toRelation()" v-if="form.phoneNumber != ''"
                                                    style="line-height: 32px;font-size: 14px;color: #00B498;cursor: pointer;">
                                                    1关联</div>
                                                <div v-else style="line-height: 32px;font-size: 14px;color: #333333;">
                                                    2关联</div>
                                            </div>
                                            <div style="display: flex;justify-content:space-between;cursor: pointer;" v-else
                                                @click="isConfirm = true">
                                                <img src="../../../assets/icon_guanlian.png"
                                                    style="width: 16px;height: 16px;padding-top:8px;padding-right:2px" />
                                                <div style="line-height: 32px;font-size: 14px;color: #00B498;">取消关联</div>
                                            </div> -->
                                        </el-form-item>
                                        <el-form-item label="员工工号" prop="serial">
                                            <el-input v-model="form.serial" placeholder="请输入" maxlength="11" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="所属部门" prop="orgCode">
                                            <el-cascader @change="handleSelectOrgId" v-model="form.orgCode"
                                                :options="options" :show-all-levels="false" :props="{
                                                    checkStrictly: true,
                                                    label: 'orgName',
                                                    value: 'orgCode',
                                                    children: 'children',
                                                }" clearable filterable></el-cascader>
                                        </el-form-item>
                                        <el-form-item label="职位" prop="positionCode">
                                            <template #label>职<span class="space"></span>位</template>
                                            <el-select v-model="form.positionCode" placeholder="请选择" clearable filterable>
                                                <el-option v-for="items in positionList" :key="items.positionCode"
                                                    :label="items.name" :value="items.positionCode"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="直接上级">
                                            <!-- <el-autocomplete class="inline-input" v-model="form.directSuperior"
                                                :fetch-suggestions="querySearch1" placeholder="请输入"
                                                :trigger-on-focus="false" @select="handleSelect1"
                                                clearable></el-autocomplete> -->
                                                <!-- {{ directSuperior }}--{{ directSuperiorList }} -->
                                                <!-- {{ form.directSuperior }}=={{ form.directSuperiorId }} -->
                                            <el-select v-model="directSuperior" @click.native="selectUser(directSuperiorList)" value-key="name"
                                                        class="select-type" placeholder="选择负责人"
                                                        size="medium" popper-class="hidden" clearable @clear="clearUser">
                                                <el-option  v-for="(user,index) in directSuperiorList" :label="user.name" :key="index" :value="user"></el-option>
                                            </el-select> 
                                        </el-form-item>
                                        <el-form-item label="入职日期" prop="employeeDate">
                                            <el-date-picker v-model="form.employeeDate" type="date" placeholder="请选择年/月/日">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item label="转正日期">
                                            <el-date-picker v-model="form.confirmationDate" type="date"
                                                placeholder="请选择年/月/日">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item label="聘用形式">
                                            <el-select v-model="form.jobNature" placeholder="请选择" clearable>
                                                <el-option v-for="item in dictionaries.job_nature" :key="item.dictId"
                                                    :label="item.dictName" :value="item.dictId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="手机号1">
                                            <el-input v-model="form.extraPhoneFirst" placeholder="请输入" maxlength="11"
                                                clearable show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="手机号2">
                                            <el-input v-model="form.extraPhoneSecond" placeholder="请输入" maxlength="11"
                                                clearable show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="工作手机号">
                                            <el-input v-model="form.workPhone" placeholder="请输入" maxlength="11" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="钉钉登录手机号"  prop="dingPhone" class="label-star">
                                            <template #label>
                                                <div class="custom-label">钉钉登录<br/>手机号</div>
                                            </template>
                                            <el-input v-model="form.dingPhone" placeholder="请输入" maxlength="11" clearable
                                                show-word-limit :disabled="!!$route.query.id"></el-input>
                                        </el-form-item>
                                    <div class="line"></div>
                                </div>
                            </div>
                            <div class="panel-item anchor-item" ref="anchor-1">
                                <div class="panel-item-title">基础信息</div>
                                <div class="panel-item-content">
                                    <el-form-item label="招聘信息来源">
                                        <template #label>
                                            <div class="custom-label">招聘信息<br/>来源</div>
                                        </template>
                                        <el-select v-model="form.recruitOrigin" placeholder="请选择" clearable>
                                            <el-option v-for="item in dictionaries.recruit_origin"
                                                :key="item.dictId" :label="item.dictName" :value="item.dictId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="身份证号码">
                                        <el-input v-model="form.idCardNumber" placeholder="请输入身份证号码" clearable
                                            maxlength="18" show-word-limit></el-input>
                                    </el-form-item>
                                    <el-form-item label="出生日期">
                                        <el-date-picker v-model="form.dateOfBirth" type="date"
                                            placeholder="请选择年/月/日">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="属相">
                                        <template #label>属<span class="space"></span>相</template>
                                        <el-select v-model="form.zodiac" placeholder="请选择" clearable>
                                            <el-option v-for="item in dictionaries.zodiac" :key="item.dictId"
                                                :label="item.dictName" :value="item.dictId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="最高学历">
                                        <el-select v-model="form.educationalLevel" placeholder="请选择" clearable>
                                            <el-option v-for="item in dictionaries.educational_level"
                                                :key="item.dictId" :label="item.dictName" :value="item.dictId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="婚姻状况">
                                        <el-select v-model="form.maritalStatus" placeholder="请选择" clearable>
                                            <el-option v-for="item in dictionaries.marital_status"
                                                :key="item.dictId" :label="item.dictName" :value="item.dictId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="汽车驾照">
                                        <el-select v-model="form.drivingLicenseLevel" placeholder="请选择" clearable>
                                            <el-option v-for="item in dictionaries.driving_license_level"
                                                :key="item.dictId" :label="item.dictName" :value="item.dictId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="微信号">
                                        <el-input v-model="form.wechatNumber" placeholder="请输入" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="邮箱地址">
                                        <el-input v-model="form.email" placeholder="请输入" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="爱好/专长">
                                        <el-input v-model="form.hobby" placeholder="请输入" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="身高(cm)">
                                        <el-input v-model="form.height" placeholder="请输入" maxlength="3" clearable
                                            show-word-limit></el-input>
                                    </el-form-item>
                                    <el-form-item label="体重(kg)">
                                        <el-input v-model="form.weight" placeholder="请输入" maxlength="3" clearable
                                            show-word-limit></el-input>
                                    </el-form-item>
                                    <el-form-item label="政治面貌">
                                        <el-select v-model="form.politicalAffiliation" placeholder="请选择" clearable>
                                            <el-option v-for="item in dictionaries.political_affiliation"
                                                :key="item.dictId" :label="item.dictName" :value="item.dictId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="籍贯">
                                        <template #label>籍<span class="space"></span>贯</template>
                                        <el-input v-model="form.nativePlace" placeholder="请输入" maxlength="12" clearable
                                            show-word-limit></el-input>
                                    </el-form-item>
                                    <el-form-item label="民族" prop="nation">
                                        <template #label>民<span class="space"></span>族</template>
                                        <el-input v-model="form.nation" placeholder="请输入" maxlength="12" clearable
                                            show-word-limit></el-input>
                                    </el-form-item>
                                    <el-form-item label="户口性质">
                                        <el-select v-model="form.householdType" placeholder="请选择" clearable>
                                            <el-option v-for="item in dictionaries.household_type" :key="item.dictId"
                                                :label="item.dictName" :value="item.dictId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!-- <el-form-item label="户口所在地">
                                        <el-cascader :options="addressOptions" v-model="form.householdResidenceCode"
                                            @change="onChangeAddress($event, 1)" filterable clearable></el-cascader>
                                    </el-form-item> -->
                                    <el-form-item label="身份证详细地址">
                                        <template #label>
                                            <div class="custom-label">身份证<br/>详细地址</div>
                                        </template>
                                        <el-input v-model="form.householdResidenceDetail" type="textarea" clearable
                                            placeholder="请输入" size="medium" rows="3" maxlength="32" show-word-limit></el-input>
                                        <!-- <el-input v-model="form.householdResidenceDetail" placeholder="请输入" clearable
                                            maxlength="20" style="width: 610px;" show-word-limit></el-input> -->
                                    </el-form-item>
                                    <!-- <el-form-item label="现居住地" prop="name">
                                        <el-cascader :options="addressOptions" v-model="form.currentResidenceCode"
                                            @change="onChangeAddress($event, 2)" filterable clearable></el-cascader>
                                    </el-form-item> -->
                                    <el-form-item label="居住地详细地址">
                                        <template #label>
                                            <div class="custom-label">居住地<br/>详细地址</div>
                                        </template>
                                        <el-input v-model="form.currentResidenceDetail" type="textarea" clearable
                                            placeholder="请输入" size="medium" rows="3" maxlength="32" show-word-limit></el-input>
                                        <!-- <el-input v-model="form.currentResidenceDetail" placeholder="请输入" maxlength="20"
                                            clearable style="width: 610px;" show-word-limit></el-input> -->
                                    </el-form-item>
                                    <el-form-item label="紧急联系人姓名">
                                        <template #label>
                                            <div class="custom-label">紧急联系人<br/>姓名</div>
                                        </template>
                                        <el-input v-model="form.emergencyContactName" placeholder="请输入" maxlength="8"
                                            clearable show-word-limit></el-input>
                                    </el-form-item>
                                    <el-form-item label="紧急联系人电话">
                                        <template #label>
                                            <div class="custom-label">紧急联系人<br/>电话</div>
                                        </template>
                                        <el-input v-model="form.emergencyContactPhone" placeholder="请输入" maxlength="11"
                                            clearable show-word-limit></el-input>
                                    </el-form-item>
                                    <div>
                                        <el-form-item label="原单位是否存在纠纷">
                                            <template #label>
                                                <div class="custom-label">原单位是否<br/>存在纠纷</div>
                                            </template>
                                            <div class="el-input">
                                                <el-radio-group v-model="form.disputeFlag" >
                                                    <el-radio :label="1">是</el-radio>
                                                    <el-radio :label="0">否</el-radio>
                                                </el-radio-group>
                                                <el-input v-if="form.disputeFlag == 1" v-model="form.dispute" clearable
                                                    placeholder="请输入" maxlength="20" type="textarea" class="dipute-textarea" rows="3" show-word-limit></el-input>
                                            </div>
                                        </el-form-item>
                                        <el-form-item label="上传近照" >
                                            <div class="el-input my-last-photo">
                                                <headerPicture @getUrl="getImage($event)" :qrCodeUrl="form.image"></headerPicture>
                                                <div class="tips">（上传图片大小在4M以内，尺寸不限，格式为jpg，png）</div>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="relative">
                                        <div class="main-colume">
                                            <el-form-item label="是否有亲戚/朋友在公司">
                                                <template #label>
                                                <div class="custom-label">是否有亲戚/<br/>朋友在公司</div>
                                            </template>
                                                <el-radio-group v-model="form.kinFlag" class="el-input">
                                                    <el-radio label="1">是</el-radio>
                                                    <el-radio label="0">否</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                        <div class="primary-colume"  v-if="form.kinFlag == '1'">
                                            <el-form-item label="其姓名">
                                                <el-input v-model="form.kinName" placeholder="请输入" maxlength="8" clearable
                                                    show-word-limit></el-input>
                                            </el-form-item>
                                            <el-form-item label="关系">
                                                <template #label>关<span class="space"></span>系</template>
                                                <el-input v-model="form.kinRelationship" placeholder="请输入" maxlength="8"
                                                    clearable show-word-limit></el-input>
                                            </el-form-item>
                                            <el-form-item label="部门">
                                                <template #label>部<span class="space"></span>门</template>
                                                <el-input v-model="form.kinOrganization" placeholder="请输入" maxlength="12"
                                                    clearable show-word-limit></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="line"></div>
                                </div>

                            </div>
                            <div class="panel-item anchor-item" ref="anchor-2">
                                <div class="panel-item-title">工作履历<span
                                        style="font-weight: 400;font-size: 16px;color: #616363;">（时间由近至远）</span></div>
                                <div class="panel-item-content">
                                    <div v-for="(item, index) in form.workRecordList" :key="index"
                                        style="margin-bottom: 24px;">
                                        <div style="display:flex;justify-content:flex-start;align-items:center">
                                            <div class="sort-index">{{ index + 1 }}</div>
                                            <div class="sort-title">工作履历</div>
                                        </div>
                                        <div style="margin-top:26px">
                                            <div
                                                style="display:flex;height:auto;justify-content: space-between;position: relative;">
                                                <div>
                                                    <el-form-item label="起始日期">
                                                        <el-date-picker v-model="item.startTime" type="date"
                                                            placeholder="请选择年/月/日">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                    <el-form-item label="结束日期">
                                                        <el-date-picker v-model="item.endTime" type="date"
                                                            placeholder="请选择年/月/日">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                    <el-form-item label="单位名称">
                                                        <el-input v-model="item.company" placeholder="请输入"
                                                            clearable maxlength="24"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="任职部门">
                                                        <el-input v-model="item.organization" placeholder="请输入"
                                                            clearable maxlength="12" show-word-limit></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="担任职位">
                                                        <el-input v-model="item.post" placeholder="请输入"
                                                            clearable maxlength="12" show-word-limit></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="现离职原因">
                                                        <el-select v-model="item.resignationReason" placeholder="请选择"
                                                            clearable>
                                                            <el-option v-for="itm in dictionaries.resignation_reason"
                                                                :key="itm.dictId" :label="itm.dictName"
                                                                :value="itm.dictId">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="月薪">
                                                        <template #label>月<span class="space"></span>薪</template>
                                                        <el-input v-model.number="item.salary" clearable
                                                            placeholder="请输入"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="证明人">
                                                        <el-input v-model="item.certifier" placeholder="请输入" clearable
                                                            maxlength="8" show-word-limit></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="联系电话">
                                                        <el-input v-model="item.phone" placeholder="请输入" maxlength="11"
                                                            clearable show-word-limit></el-input>
                                                    </el-form-item>
                                                </div>
                                                <div class="delete" @click="deletePlus(1, index)">删除</div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="btn" @click="addPlus(1)">
                                        <div style="display:flex;justify-content:center;align-items:center">
                                            <div>
                                                <i class="el-icon-plus" style="color:#00B498"></i>
                                            </div>

                                            <div class="btn-t">添加工作履历</div>
                                        </div>
                                    </div>
                                    <div class="line"></div>
                                </div>
                            </div>
                            <div class="panel-item anchor-item" ref="anchor-3">
                                <div class="panel-item-title">教育经历<span
                                        style="font-weight: 400;font-size: 16px;color: #616363;">（学历由高至低）</span></div>
                                <div class="panel-item-content">
                                    <div v-for="(item, index) in form.educationList" :key="index"
                                        style="margin-bottom: 24px;">
                                        <div style="display:flex;justify-content:flex-start;align-items:center">
                                            <div class="sort-index">{{ index + 1 }}</div>
                                            <div class="sort-title">教育经历</div>
                                        </div>
                                        <div style="margin-top:26px">
                                            <div
                                                style="display:flex;height:auto;justify-content: space-between;position: relative;">
                                                <div>
                                                    <el-form-item label="起始日期">
                                                        <el-date-picker v-model="item.startTime" type="date"
                                                            placeholder="请选择年/月/日">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                    <el-form-item label="结束日期">
                                                        <el-date-picker v-model="item.endTime" type="date"
                                                            placeholder="请选择年/月/日">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                    <el-form-item label="学校名称">
                                                        <el-input v-model="item.institutionName" clearable
                                                            placeholder="请输入" maxlength="30"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="专业" prop="name">
                                                        <template #label>专<span class="space"></span>业</template>
                                                        <el-input v-model="item.major" placeholder="请输入" maxlength="12"
                                                            clearable show-word-limit></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="学历">
                                                        <template #label>学<span class="space"></span>历</template>
                                                        <el-select v-model="item.educationalLevel" placeholder="请选择"
                                                            clearable>
                                                            <el-option v-for="itm in dictionaries.educational_level"
                                                                :key="itm.dictId" :label="itm.dictName"
                                                                :value="itm.dictId">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="教育类型">
                                                        <el-select v-model="item.educationalMode" placeholder="请选择"
                                                            clearable>
                                                            <el-option v-for="itm in dictionaries.educational_mode"
                                                                :key="itm.dictId" :label="itm.dictName"
                                                                :value="itm.dictId">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </div>
                                                <div class="delete" @click="deletePlus(2, index)">删除</div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="btn" @click="addPlus(2)">
                                        <div style="display:flex;justify-content:center;align-items:center">
                                            <div>
                                                <i class="el-icon-plus" style="color:#00B498"></i>
                                            </div>

                                            <div class="btn-t">添加教育经历</div>
                                        </div>
                                    </div>
                                    <div class="line"></div>
                                </div>
                            </div>
                            <div class="panel-item anchor-item" ref="anchor-4">
                                <div class="panel-item-title">家庭信息</div>
                                <div class="panel-item-content">
                                    <div v-for="(item, index) in form.familyInfoList" :key="index"
                                        style="margin-bottom: 24px;">
                                        <div style="display:flex;justify-content:flex-start;align-items:center">
                                            <div class="sort-index">{{ index + 1 }}</div>
                                            <div class="sort-title">家庭成员</div>
                                        </div>
                                        <div style="margin-top:26px">
                                            <div style="display:flex;height:auto;justify-content: space-between;position: relative;">
                                                <div>
                                                    <el-form-item label="本人关系">
                                                        <el-select v-model="item.familyRelationships" placeholder="请选择"
                                                            clearable>
                                                            <el-option v-for="itm in dictionaries.family_relationships"
                                                                :key="itm.dictId" :label="itm.dictName"
                                                                :value="itm.dictId">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="姓名">
                                                        <template #label>姓<span class="space"></span>名</template>
                                                        <el-input v-model="item.name" placeholder="请输入"
                                                            clearable></el-input>
                                                    </el-form-item>
                                                    <!-- <el-form-item label="是否为紧急联系人（至少一位）" prop="" label-width="124px"
                                                        style="margin-right:92px">
                                                        <template #label>
                                                            <div style="line-height: 16px;">是否为紧急联系人
                                                                （至少一位）
                                                            </div>
                                                        </template>
                                                        <el-radio-group v-model="item.emergencyFlag">
                                                            <el-radio label="1">是</el-radio>
                                                            <el-radio label="0">否</el-radio>
                                                        </el-radio-group>
                                                    </el-form-item> -->
                                                    <!-- <el-form-item label="出生日期">
                                                        <el-date-picker v-model="item.dateOfBirth" type="date"
                                                            placeholder="请选择年/月/日">
                                                        </el-date-picker>
                                                    </el-form-item> -->
                                                    <el-form-item label="工作单位">
                                                        <el-input v-model="item.company" placeholder="请输入" clearable
                                                            maxlength="20" show-word-limit></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="职务">
                                                        <template #label>职<span class="space"></span>务</template>
                                                        <el-input v-model="item.post" placeholder="请输入" maxlength="8"
                                                            clearable show-word-limit></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="联系电话">
                                                        <el-input v-model="item.phone" placeholder="请输入" maxlength="11"
                                                            clearable show-word-limit></el-input>
                                                    </el-form-item>
                                                </div>
                                                <div class="delete" @click="deletePlus(3, index)">删除</div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="btn" @click="addPlus(3)">
                                        <div style="display:flex;justify-content:center;align-items:center">
                                            <div>
                                                <i class="el-icon-plus" style="color:#00B498"></i>
                                            </div>

                                            <div class="btn-t">添加家庭成员</div>
                                        </div>
                                    </div>
                                    <div class="line"></div>
                                </div>
                            </div>
                            <div class="panel-item anchor-item" ref="anchor-5">
                                <div class="panel-item-title">培训经历<span
                                        style="font-weight: 400;font-size: 16px;color: #616363;">（非必填项）</span></div>
                                <div class="panel-item-content">
                                    <div v-for="(item, index) in form.trainingInfoList" :key="index"
                                        style="margin-bottom: 24px;">
                                        <div style="display:flex;justify-content:flex-start;align-items:center">
                                            <div class="sort-index">{{ index + 1 }}</div>
                                            <div class="sort-title">培训经历</div>
                                        </div>
                                        <div style="margin-top:26px">
                                            <div
                                                style="display:flex;height:auto;justify-content: space-between;position: relative;">
                                                <div>
                                                    <el-form-item label="起始日期">
                                                        <el-date-picker v-model="item.startTime" type="date" clearable
                                                            placeholder="请选择年/月/日">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                    <el-form-item label="结束日期">
                                                        <el-date-picker v-model="item.endTime" type="date" clearable
                                                            placeholder="请选择年/月/日">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                    <el-form-item label="培训方式">
                                                        <el-select v-model="item.trainingMode" placeholder="请选择"
                                                            clearable>
                                                            <el-option v-for="itm in dictionaries.training_mode"
                                                                :key="itm.dictId" :label="itm.dictName"
                                                                :value="itm.dictId">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="培训机构">
                                                        <el-input v-model="item.institutionName" placeholder="请输入"
                                                            clearable maxlength="16" show-word-limit></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="获取证书">
                                                        <!-- <el-input v-model="item.certificate" placeholder="请输入" clearable
                                                            maxlength="20" show-word-limit></el-input> -->
                                                        <el-input v-model="item.certificate" type="textarea"
                                                            clearable placeholder="请输入" size="medium" rows="3"
                                                            maxlength="16"
                                                            show-word-limit></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="培训内容" >
                                                        <el-input v-model="item.trainingContent" type="textarea"
                                                            clearable placeholder="请输入" size="medium" rows="3"
                                                            maxlength="64"
                                                            show-word-limit></el-input>
                                                    </el-form-item>
                                                </div>
                                                <div class="delete" @click="deletePlus(4, index)">删除</div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="btn" @click="addPlus(4)">
                                        <div style="display:flex;justify-content:center;align-items:center">
                                            <div>
                                                <i class="el-icon-plus" style="color:#00B498"></i>
                                            </div>

                                            <div class="btn-t">添加培训经历</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                        <div style="height:40px"></div>
                    </div>
                    <transition name="el-fade-in">
                        <div class="panel-right" v-show="footer">
                            <el-tabs tab-position="right" v-model="activeBtn" @tab-click="handleClickAchors"
                                class="vertical-tabs" style="height: auto;">
                                <el-tab-pane v-for="(item, index) in anchors" :key="index" :label="item.label"
                                    :name="String(index)"></el-tab-pane>
                            </el-tabs>
                        </div>
                    </transition>
                </div>
            </div>
            <div v-if="activeName == '2'" class="main2">
                <div class="title">角色权限</div>
                <div class="main2-content">
                    <el-form :inline="true" :model="form" ref="form" class="form" size="small" label-width="82px"
                        :rules="rules" label-position="right">
                        <el-form-item label="钉钉角色：" style="margin-right:197px" v-if="$route.query.id">
                            <div v-if="form.autoRoleName && form.autoRoleName.length > 0" style="display:flex;">
                                <div v-for="(item, index) in form.autoRoleName">
                                    {{ item }}<span v-if="index != form.autoRoleName.length - 1">,</span>
                                </div>
                            </div>

                            <div v-else>--</div>
                            <!-- {{ form.autoRoleName || '--' }} -->
                        </el-form-item>
                        <el-form-item label="OA角色">
                            <el-select v-model="form.roleIds" placeholder="请选择" multiple>
                                <el-option v-for="item in roleDataList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </div>
        <transition name="el-fade-in">
            <div class="footer" v-show="footer" :class="[isCollapsed?'footer-collapsed':'']">
                <div class="footer-btn-b" @click="back()">返回</div>
                <div class="footer-btn-r" @click="reset()" v-if="parArray.indexOf('employee_update') != -1">重置</div>
                <div class="footer-btn-s" @click="save()" v-if="parArray.indexOf('employee_update') != -1">确认</div>
            </div>
        </transition>
        <!--关联 -->
        <el-dialog title="关联应聘信息" :visible.sync="isRelative" width="978px" append-to-body>
            <div class="dialog-body">
                <div class="dialog-title">
                    <el-form :inline="true" :model="form" ref="form" class="form" size="small" label-width="82px"
                        style="width:300px" :rules="rules">
                        <el-form-item label="应聘信息联系电话">
                            <template #label>
                                <div style="line-height: 18px;"><span
                                        style="color: #F56C6C;margin-right: 4px;">*</span>应聘信息联系电话
                                </div>
                            </template>
                            <el-input v-model="phone" placeholder="请输入" maxlength="11" show-word-limit
                                style="width:204px"></el-input>
                        </el-form-item>
                    </el-form>
                    <div style="width:60px">
                        <el-button type="primary" @click="getReList()" size="small" :disabled="!phone">查询</el-button>
                    </div>
                </div>
                <div class="dialog-line"></div>
                <div class="dialog-content">
                    <div style="display: flex;height: 32px;">
                        <div class="title-line"></div>
                        <div class="title-name">查询结果</div>
                    </div>
                    <div class="dialog-main">
                        <!-- <div class="dialog-main-no">暂无可关联信息</div> -->
                        <div class="dialog-list">
                            <!-- <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list"
                                @selection-change="onMultipleSelection">
                            </lb-table> -->
                            <el-table ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%;"
                                @row-click="rowClick" :header-cell-style="{ background: '#F5F5F5', color: '#2F3030' }"
                                show-overflow-tooltip highlight-current-row stripe>
                                <el-table-column label=" " width="55" align="center" fixed="left">
                                    <template slot-scope="scope">
                                        <el-radio :label="scope.row.id" v-model="applicantBaseId"
                                            v-if="scope.row.relateEmployeeLabel == '否'">
                                            {{ '' }}
                                        </el-radio>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="applicantTime" label="应聘日期" width="160"></el-table-column>
                                <el-table-column prop="name" label="应聘者姓名" width="100"
                                    show-overflow-tooltip></el-table-column>
                                <el-table-column prop="gender" label="性别" show-overflow-tooltip align="center">
                                    <template slot-scope="scope">
                                        <div style="display:flex;width:100%;justify-content:center">
                                            {{ scope.row.gender }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="orgName" label="应聘者部门" width="160"
                                    show-overflow-tooltip></el-table-column>

                                <el-table-column prop="recruitPost" label="应聘者岗位" width="200"
                                    show-overflow-tooltip></el-table-column>
                                <el-table-column prop="relateEmployeeLabel" label="是否已关联员工" width="200" align="center"
                                    show-overflow-tooltip></el-table-column>
                                <el-table-column prop="statusLabel" label="应聘状态" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <div style="display:flex;width:100%">
                                            <div v-if="scope.row.statusLabel == '已面试' || scope.row.statusLabel == '已入职'"
                                                style="width: 8px;height: 8px;background: #00B498;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px">
                                            </div>
                                            <div v-if="scope.row.statusLabel == '淘汰' || scope.row.statusLabel == '离职'"
                                                style="width: 8px;height: 8px;background: #E23C58;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px">
                                            </div>
                                            <div v-if="scope.row.statusLabel == '备选' || scope.row.statusLabel == '放弃入职'"
                                                style="width: 8px;height: 8px;background: #F5C401;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px">
                                            </div>
                                            <div v-if="scope.row.statusLabel == '录用'"
                                                style="width: 8px;height: 8px;background: #2D5DCF;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px">
                                            </div>
                                            <div style="flex:1">{{ scope.row.statusLabel }}</div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="remark" label="备注" show-overflow-tooltip
                                    fixed="right"></el-table-column>
                            </el-table>


                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isRelative = false">取 消</el-button>
                <el-button type="primary" @click="submitRelative()" v-if="isR">关联</el-button>
                <el-button v-if="!isR" disabled>关联</el-button>
            </span>
        </el-dialog>
        <!--取消关联 -->
        <el-dialog title="取消关联" :visible.sync="isNoRelative" width="552px" append-to-body>
            <div class="dialog-body">
                <div class="dialog-title">
                    <el-form :inline="true" :model="form" ref="form" class="form" size="small" label-width="100px"
                        style="margin-left:55px" :rules="rules">
                        <el-form-item label="登录手机号">
                            <template #label>
                                <div style="line-height: 32px;"><span
                                        style="color: #F56C6C;margin-right: 4px;">*</span>登录手机号
                                </div>
                            </template>
                            <el-input v-model="this.form.phone" placeholder="请输入" maxlength="11" show-word-limit
                                style="width:204px"></el-input>
                        </el-form-item>
                    </el-form>
                    <div>
                        <div style="display: flex;justify-content:space-between;">
                            <img src="../../../assets/icon_guanlian.png"
                                style="width: 16px;height: 16px;padding-top:8px;padding-right:2px" />
                            <div style="line-height: 32px;font-size: 14px;color: #00B498;" @click="isConfirm = true">取消关联
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!--确认 -->
        <el-dialog title="提示" :visible.sync="isConfirm" width="268px" append-to-body>
            <span
                style="font-size: 14px;color: #2F3030;line-height: 22px;text-align: center;margin-left:12px">是否确认取消关联应聘信息？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isConfirm = false">取 消</el-button>
                <el-button type="primary" @click="qSubmit()">确认</el-button>
            </span>
        </el-dialog>
        <org-picker title="选择直接上级" :multiple="false" ref="orgPicker" @ok="selected" />
    </div>
</template>
  
<script>
import headerPicture from '../../../components/headerPicture.vue'
import LbTable from '../../../components/lb-table/lb-table'
import addressData from '@/components/addressData.js'
import OrgPicker from "@/components/OrgPicker";
export default {
    name: 'addStaff',
    components: {
        headerPicture,
        LbTable,
        OrgPicker
    },
    props: {
        pageActive: {
        type: String,
        required: false, // 可选
        default: '0'     // 默认值
        }
    },
    watch: {
      pageActive(newValue, oldValue) {
         if (!this.isGo && this.activeBtn != newValue) {
            this.activeBtn = newValue
            console.log('info>>',this.activeBtn)
         }
      },
    //   '$route.query.id'(val) { 
    //         let whiteName = ['addSatff','editSatff']
    //         if (whiteName.includes(this.$route.name)) {
    //             this.reset()
    //         }
    //     },
    },
    activated() {
        let whiteName = ['addSatff','editSatff']
        if (whiteName.includes(this.$route.name)) {
            this.reset()
        }
    },
    data() {
        return {
            footer :false,
            applicantBaseId: null,
            phone: '',
            tags: [
                {
                    label: '员工信息',
                    name: '1'
                },
                {
                    label: '角色权限',
                    name: '2'
                }
            ],
            anchors: [
                {
                    label: '主要信息',
                    name: '1'
                },
                {
                    label: '基础信息',
                    name: '2'
                },
                {
                    label: '工作履历',
                    name: '3'
                },
                {
                    label: '教育经历',
                    name: '4'
                },
                {
                    label: '家庭信息',
                    name: '5'
                },
                {
                    label: '培训经历',
                    name: '6'
                }
            ],
            activeName: '1',
            activeBtn: '0', //锚点按钮
            stepData: ['区域1', '区域2', '区域3', '区域4'],
            contentDiv: null, //锚点区域
            isGo: false, //是否滚动
            isR: false,
            parArray:[],
            form: {
                applicantBaseId: null,
                reallyName: '',
                sex: '1',
                phoneNumber: '',
                serial: '',
                orgCode: [],
                positionCode: '',
                directSuperior: '',
                directSuperiorId: '',
                employeeDate: '',
                confirmationDate: '',
                recruitOrigin: null,
                jobNature: null,
                extraPhoneFirst: '',
                extraPhoneSecond: '',
                workPhone: '',
                dingPhone: '',
                recruitType: null,
                zodiac: null,
                idCardNumber: '',
                dateOfBirth: '',
                educationalType: null,
                educationalLevel: null,
                maritalStatus: null,
                image: '',
                drivingLicenseLevel: null,
                wechatNumber: '',
                email: '',
                hobby: '',
                height: null,
                weight: null,
                politicalAffiliation: '',
                nativePlace: '',
                householdType: null,
                householdResidence: '',
                householdResidenceCode: [],
                currentResidence: '',
                currentResidenceCode: [],
                householdResidenceDetail: '',
                currentResidenceDetail: '',
                disputeFlag: null,
                dispute: '',
                kinFlag: null,
                kinName: '',
                kinRelationship: '',
                kinOrganization: '',
                nation: '',
                workRecordList: [
                    {
                        post: null,
                        phone: '',
                        company: '',
                        organization: '',
                        resignationReason: '',
                        resignationReasonLabel: '',
                        salary: '',
                        certifier: '',
                        startTime: '',
                        endTime: ''
                    }
                ],
                educationList: [
                    {
                        educationalLevel: null,
                        educationalLevelLabel: '',
                        institutionName: '',
                        major: '',
                        educationalMode: null,
                        educationalModeLabel: '',
                        startTime: '',
                        endTime: '',
                    }
                ],
                familyInfoList: [
                    {
                        name: '',
                        dateOfBirth: '',
                        company: '',
                        post: '',
                        phone: '',
                        familyRelationships: null,
                        familyRelationshipsLabel: '',
                        emergencyFlag: null
                    }
                ],
                trainingInfoList: [
                    {
                        institutionName: '',
                        trainingContent: '',
                        trainingMode: null,
                        trainingModeLabel: '',
                        certificate: '',
                        startTime: '',
                        endTime: ''

                    }
                ],
                autoRoleName: '',
                roleIds: [],
                roleName: [],
            },
            rules: {
                reallyName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                positionCode: [
                    { required: true, message: '请选择职位', trigger: 'change' }
                ],
                employeeDate: [
                    { required: true, message: '请输入入职日期', trigger: 'change' }
                ],
                phoneNumber: [
                    { required: true, message: '请输入登录手机号', trigger: 'blur' }
                ],
                serial: [
                    { required: true, message: '请输入员工工号', trigger: 'blur' }
                ],
                orgCode: [
                    { required: true, message: '请选择部门', trigger: 'change' }
                ],
                dingPhone: [
                    { required: true, message: '请输入钉钉登录手机号', trigger: 'blur' }
                ]
            },
            isRelative: false,
            isNoRelative: false,
            isConfirm: false,
            list: [

            ],
            options: [],
            positionList: [],
            timeout: null,
            dictionaries: {},
            roleDataList: [],
            directSuperior:{},
            directSuperiorList:[]
        }
    },
    computed:{
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    created() {
        console.log(111)
        this.dictionaries = this.fmObjToArr(JSON.parse(sessionStorage.getItem('dictionaries')))
        console.log(this.dictionaries)
        this.department()
        this.getPositionList()
        console.log(this.dict('job_nature'))
        this.dict('job_nature')
        this.dict('recruit_type')
        this.dict('zodiac')
        this.dict('educational_type')
        this.dict('marital_status')
        this.dict('driving_license_level')
        this.dict('political_affiliation')
        this.dict('household_type')
        this.dict('resignation_reason')
        this.dict('educational_mode')
        this.dict('educational_level')
        this.dict('family_relationships')
        this.dict('training_mode')
        this.dict('recruit_origin')
        this.trimAddressData()
        this.getRoleList()
        // if (this.$route.query.id) {
        //     this.getDetail(this.$route.query.id)
        // }
        // 权限设定判断 normsCode
        this.limits = JSON.parse(sessionStorage.getItem("limit"))
        const params = this.limits.buttonTreeDto.find(
            (item) => item.menuCode === "roster"
        )
        params.buttonList.forEach((item) => {
            this.parArray.push(item.code)
        })
        setTimeout(()=>{
             this.footer = true
        },500)
    },
    mounted() {
       
    },
    methods: {
        selectUser(select) {
            if (select && select.length > 0) {
                select[0].serial=''
            }
            this.$refs.orgPicker.show(select,'user')
        },
        // 选中人员回显
        selected(users) {
            if (users&&users.length==0) return
            const user = users[0]
            user.name = user.serial + user.name
            user.serial = ''
            this.directSuperiorList = users
            this.directSuperior = user
            this.form.directSuperior = user.name
            this.form.directSuperiorId = user.id
        },
        // 删除直接上级
        clearUser(){
            this.directSuperior = {}
            this.directSuperiorList = []
            this.form.directSuperior = ''
            this.form.directSuperiorId = ''
        },
        getEmptyProperties(obj) {
            let emptyProperties = [];
            Object.keys(obj).forEach(key => {
                if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
                    emptyProperties.push(key);
                }
            });
            return emptyProperties;
        },
        qSubmit() {
            this.applicantBaseId = null
            this.form.applicantBaseId = null
            this.isConfirm = false
            this.isNoRelative = false
            // this.$refs.form.resetFields()
        },
        submitRelative() {
            this.isRelative = false
            this.form.applicantBaseId = this.applicantBaseId
            let arr = this.getEmptyProperties(this.form)
            console.log(arr)
            this.getApplyDetail(this.form.applicantBaseId, arr)
        },
        getApplyDetail(id, arrNull) {
            let ids = []
            ids.push(id)
            let data = {
                ids: ids
            }
            this.axios.post('/oa/sys/applicant/detail/list', data).then((res) => {
                if (res.code == 0) {
                    const data = res.data[0]
                    data.jobNature = String(data.jobNature || '')
                    data.recruitOrigin = String(data.recruitOrigin)
                    data.recruitType = String(data.recruitType)
                    data.zodiac = String(data.zodiac)
                    data.drivingLicenseLevel = String(data.drivingLicenseLevel)
                    data.politicalAffiliation = String(data.politicalAffiliation)
                    data.maritalStatus = String(data.maritalStatus)
                    data.householdType = String(data.householdType)
                    data.educationalLevel = String(data.educationalLevel)
                    data.kinFlag = String(data.kinFlag)
                    if (data.workRecordList) {
                        data.workRecordList.forEach(item => {
                            item.resignationReason = String(item.resignationReason)
                            item.educationalMode = String(item.educationalMode)
                        })
                    }
                    if (data.educationList) {
                        data.educationList.forEach(item => {
                            item.educationalLevel = String(item.educationalLevel)
                            item.educationalMode = String(item.educationalMode)
                        })

                    }
                    if (data.familyInfoList) {
                        data.familyInfoList.forEach(item => {
                            item.familyRelationships = String(item.familyRelationships)
                            item.emergencyFlag = String(item.emergencyFlag)
                        })
                    }
                    if (data.trainingInfoList) {
                        data.trainingInfoList.forEach(item => {
                            item.trainingMode = String(item.trainingMode)
                        })
                    }
                    if (data.householdResidenceCode) {
                        let arr = []
                        data.householdResidenceCode.forEach(item => {
                            arr.push(Number(item))
                        })
                        console.log(arr)
                        data.householdResidenceCode = arr
                    }
                    if (data.currentResidenceCode) {
                        let arr = []
                        data.currentResidenceCode.forEach(item => {
                            arr.push(Number(item))
                        })
                        console.log(arr)
                        data.currentResidenceCode = arr
                    }
                    let obj = {}
                    obj = data
                    console.log(obj)
                    let index = arrNull.indexOf('positionCode')
                    if (index > -1) arrNull.splice(index, 1)
                    let index1 = arrNull.indexOf('orgCode')
                    if (index1 > -1) arrNull.splice(index1, 1)
                    // let index2 = arrNull.indexOf('workRecordList')
                    // if (index2 > -1) arrNull.splice(index2, 1)
                    arrNull.forEach(item => {
                        this.form[item] = obj[item]
                    })
                    if (this.form.householdResidenceCode && this.form.householdResidenceCode.length > 0) {
                        this.form.householdResidenceCode = this.form.householdResidenceCode
                    } else {
                        this.form.householdResidenceCode = obj.householdResidenceCode
                    }
                    if (this.form.currentResidenceCode && this.form.currentResidenceCode.length > 0) {
                        this.form.currentResidenceCode = this.form.currentResidenceCode
                    } else {
                        this.form.currentResidenceCode = obj.currentResidenceCode
                    }
                    this.form.workRecordList = this.form.workRecordList.filter(item => this.getEmptyProperties(item).length != 10)
                    this.form.educationList = this.form.educationList.filter(item => this.getEmptyProperties(item).length != 8)
                    this.form.familyInfoList = this.form.familyInfoList.filter(item => this.getEmptyProperties(item).length != 8)
                    this.form.trainingInfoList = this.form.trainingInfoList.filter(item => this.getEmptyProperties(item).length != 7)
                    if (this.form.workRecordList && this.form.workRecordList.length > 0) {
                        this.form.workRecordList = this.form.workRecordList.concat(obj.workRecordList)
                    } else {
                        this.form.workRecordList = obj.workRecordList
                    }
                    if (this.form.educationList && this.form.educationList.length > 0) {
                        this.form.educationList = this.form.educationList.concat(obj.educationList)
                    } else {
                        this.form.educationList = obj.educationList
                    }
                    if (this.form.familyInfoList && this.form.familyInfoList.length > 0) {
                        this.form.familyInfoList = this.form.familyInfoList.concat(obj.familyInfoList)
                    } else {
                        this.form.familyInfoList = obj.familyInfoList
                    }
                    if (this.form.trainingInfoList && this.form.trainingInfoList.length > 0) {
                        this.form.trainingInfoList = this.form.trainingInfoList.concat(obj.trainingInfoList || [])
                    } else {
                        this.form.trainingInfoList = obj.trainingInfoList || []
                    }
                    // this.form = obj
                    this.form.recruitOrigin = obj.recruitOrigin
                    this.form.idCardNumber = obj.idCardNumber
                    this.form.dateOfBirth = obj.dateOfBirth
                    this.form.zodiac = obj.zodiac
                    this.form.educationalLevel = obj.educationalLevel
                    this.form.maritalStatus = obj.maritalStatus
                    this.form.drivingLicenseLevel = obj.drivingLicenseLevel
                    this.form.householdType = obj.householdType
                    this.form.politicalAffiliation = obj.politicalAffiliation
                    this.form.disputeFlag = obj.disputeFlag
                    this.form.dispute = obj.dispute
                    this.form.kinFlag = obj.kinFlag
                    this.form.kinName = obj.kinName
                    this.form.kinRelationship = obj.kinRelationship
                    this.form.kinOrganization = obj.kinOrganization
                    this.form.emergencyContactName = obj.emergencyContactName
                    this.form.emergencyContactPhone = obj.emergencyContactPhone
                } else {
                    this.$message.error(res.message)
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        rowClick(val) {
            console.log(val)
            this.applicantBaseId = val.id

        },
        toRelation() {
            this.isRelative = true
            this.phone = this.form.phoneNumber
            this.getReList()
        },
        getReList() {

            this.axios.get('/oa/sys/applicant/relate/' + this.phone).then((res) => {
                if (res.code == 0) {
                    this.list = res.data || []
                    this.isR = this.list.some(item => item.relateEmployeeLabel == '否')
                } else {
                    this.$message.error(res.message)
                }
                console.log(res)
            }).catch((err) => {
                console.log(err)
            })
        },
        back() {
            this.$router.go(-1)
        },
        clearForm() {
            for (let key in this.form) {
                if (this.form.hasOwnProperty(key)) {
                    // 根据属性类型设置默认值
                    switch (typeof this.form[key]) {
                        case 'object':
                            // 如果属性是数组，则清空数组
                            if (Array.isArray(this.form[key])) {
                                // console.log(this.form[key])
                                // this.form[key] = this.form[key]
                                if (this.form[key].length > 0) {
                                    this.form[key].forEach(item => {
                                        if (typeof item ==='object') {
                                            this.clearNestedObject(item);
                                        }
                                        
                                    });
                                }

                            } else {
                                // 如果属性是对象，则递归清空
                                this.clearNestedObject(this.form[key]);
                            }
                            break;
                        case 'string':
                            this.form[key] = '';
                            break;
                        case 'number':
                        case 'boolean':
                            this.form[key] = null;
                            break;
                        default:
                            this.form[key] = '';
                    }
                }
            }
        },
        clearNestedObject(obj) {
            for (let key in obj) {
                if (key == 'startTime' || key == 'endTime' || key == 'dateOfBirth') {
                    obj[key] = null
                }
                if (obj.hasOwnProperty(key)) {
                    if (typeof obj[key] === 'object') {
                        if (Array.isArray(obj[key])) {
                            obj[key] = [];
                        } else {
                            this.clearNestedObject(obj[key]);
                        }
                    } else {
                        switch (typeof obj[key]) {
                            case 'string':
                                obj[key] = '';
                                break;
                            case 'number':
                            case 'boolean':
                                obj[key] = null;
                                break;
                            default:
                                obj[key] = '';
                        }
                    }
                }
            }
        },
        reset() {
            if (this.$route.query.id) {
                this.getDetail(this.$route.query.id)
            } else {
                this.$refs.form.resetFields()
                this.directSuperior = {}
                this.directSuperiorList = []
                this.clearForm()
                this.$forceUpdate()

            }
        },
        getDetail(id) {
            this.axios.get('/oa/sys/employee/' + id).then((res) => {
                if (res.code == 0) {
                    res.data.jobNature = String(res.data.jobNature)
                    res.data.recruitType = String(res.data.recruitType)
                    res.data.zodiac = String(res.data.zodiac)
                    res.data.drivingLicenseLevel = String(res.data.drivingLicenseLevel)
                    res.data.politicalAffiliation = String(res.data.politicalAffiliation)
                    res.data.maritalStatus = String(res.data.maritalStatus)
                    res.data.householdType = String(res.data.householdType)
                    res.data.educationalType = String(res.data.educationalType)
                    res.data.recruitOrigin = String(res.data.recruitOrigin)
                    res.data.kinFlag = String(res.data.kinFlag)
                    res.data.educationalLevel = String(res.data.educationalLevel)
                    if (res.data.workRecordList) {
                        res.data.workRecordList.forEach(item => {
                            item.resignationReason = String(item.resignationReason || '')
                            item.educationalMode = String(item.educationalMode || '')
                        })
                    }
                    if (res.data.educationList) {
                        res.data.educationList.forEach(item => {
                            item.educationalLevel = String(item.educationalLevel || '')
                            item.educationalMode = String(item.educationalMode || '')
                        })

                    }
                    if (res.data.familyInfoList) {
                        res.data.familyInfoList.forEach(item => {
                            item.familyRelationships = String(item.familyRelationships || '')
                            item.emergencyFlag = String(item.emergencyFlag)
                        })
                    }
                    if (res.data.trainingInfoList) {
                        res.data.trainingInfoList.forEach(item => {
                            item.trainingMode = String(item.trainingMode || '')
                        })
                    }
                    if (res.data.householdResidenceCode) {
                        let arr = []
                        res.data.householdResidenceCode.forEach(item => {
                            arr.push(Number(item))
                        })
                        console.log(arr)
                        res.data.householdResidenceCode = arr
                    }
                    if (res.data.currentResidenceCode) {
                        let arr = []
                        res.data.currentResidenceCode.forEach(item => {
                            arr.push(Number(item))
                        })
                        console.log(arr)
                        res.data.currentResidenceCode = arr
                    }
                    this.form = res.data
                    if (this.form.directSuperiorId) {
                        this.directSuperior = {
                            id: this.form.directSuperiorId,
                            name: this.form.directSuperior,
                            type:'user'
                        }
                        this.directSuperiorList = [this.directSuperior]
                    }else{
                        this.directSuperior = {}
                        this.directSuperiorList = []
                    }
                    
                    console.log('detail>>',this.form)
                } else {
                    this.$message.error(res.message)
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        save() {
            this.form.workRecordList = this.form.workRecordList.filter(item => this.getEmptyProperties(item).length != 10)
            this.form.educationList = this.form.educationList.filter(item => this.getEmptyProperties(item).length != 8)
            this.form.familyInfoList = this.form.familyInfoList.filter(item => this.getEmptyProperties(item).length != 8)
            this.form.trainingInfoList = this.form.trainingInfoList.filter(item => this.getEmptyProperties(item).length != 7)
            let params = {}
            params = Object.assign(params, this.form)
            if (Array.isArray(this.form.orgCode)) {
                params.orgCode = this.form.orgCode[this.form.orgCode.length - 1]
            } else {
                params.orgCode = this.form.orgCode
            }
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.$route.query.id) {
                        params.id = this.$route.query.id
                        this.axios.put('/oa/sys/employee', params).then((res) => {
                            if (res.code == 0) {
                                this.$message({ message: '修改成功', type: 'success' })
                                // this.getDetail(this.$route.query.id)
                                this.$router.push({ path: '/staffManagement/roster' })
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    } else {
                        this.axios.post('/oa/sys/employee', params).then((res) => {
                            if (res.code == 0) {
                                this.$message({ message: '提交成功', type: 'success' })
                                this.reset()
                                this.$router.push({ path: '/staffManagement/roster' })
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }

                } else {
                    return false
                }
            })
        },
        onMultipleSelection() {

        },
        // 角色下拉列表数据
        getRoleList() {
            const data = {
                pageNo: 1,
                pageSize: 10000
            }
            this.$api.rolePageList(data).then(res => {
                console.log(res)
                if (res.code == 0) {
                    this.roleDataList = res.data.list
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        // 初始化地区数据
        trimAddressData() {
            // console.log("初始化地区数据", addressData)
            const arr = []
            for (const province in addressData) {
                const childrenCity = []
                for (const city in addressData[province]) {
                    const childrenArea = []
                    addressData[province][city].forEach((e, i) => {
                        childrenArea.push({ title: '市区', label: e, value: i })
                    })
                    childrenCity.push({ title: '城市', label: city, children: childrenArea, value: city })
                    // console.log(childrenCity.children)
                }
                arr.push({ title: '省份', label: province, children: childrenCity, value: province })
            }
            // 修改 value 值
            arr.forEach((e, i) => {
                e.value = i
                e.children.forEach((ee, ii) => {
                    ee.value = ii
                })
            })
            this.addressOptions = arr
        },
        // 地区修改
        onChangeAddress(val, type) {
            // console.log(val)
            const addressOptions = this.addressOptions
            let province = ''
            let city = ''
            let region = ''
            for (let i = 0; i < val.length; i++) {
                if (i === 0) {
                    province = addressOptions[val[0]].label
                    console.log('省份', province)
                    continue
                }
                if (i === 1) {
                    city = addressOptions[val[0]].children[val[1]].label
                    console.log('城市', city)
                    continue
                }
                if (i === 2) {
                    region = addressOptions[val[0]].children[val[1]].children[val[2]].label
                    console.log('市区', region)
                    continue
                }
            }
            if (type == 1) {
                this.form.householdResidence = province + city + region
                console.log(this.form.householdResidence)
            } else {
                this.form.currentResidence = province + city + region
            }

        },
        getImage(val) {
            this.form.image = val

        },
        dict(val) {
            this.dictionaries.forEach((item) => {
                // console.log(item)
                if (item.value == val) {
                    this.dictionaries[val] = item.label
                }
            })
        },
        fmObjToArr(data) {
            let arr = []
            for (let key in data) {
                let tem = []
                for (let i in data[key]) {
                    let obj = {
                        dictId: i,
                        dictName: data[key][i]

                    }
                    tem.push(obj)
                }
                arr.push({
                    label: tem, // label 字段
                    value: key   // value字段
                })
            }
            console.log(arr)
            return arr
        },
        querySearch1(queryString, cb) {
            this.axios
                .get('/oa/sys/employee/superior/' + this.form.directSuperior)
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.forEach((item) => {
                            item.value = item.name
                        })

                        var results = queryString ? res.data : [];
                        // 调用 callback 返回建议列表的数据
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                            cb(results);
                        }, 3000 * Math.random());
                        // cb(results);
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSelect1(item) {
            this.form.directSuperior = item.name

        },
        handleSelectOrgId(e) {
            console.log(e)
            this.form.orgCode = e
        },
        // 查询职位下拉列表数据
        getPositionList() {
            const data = {}
            this.axios.post('/sys/v2/user/position/listSelect', data).then((res) => {
                if (res.code == 0) {
                    this.positionList = res.data
                }
                console.log(res)
            }).catch((err) => {
                console.log(err)
            })
        },
        // 部门选择列表
        department() {
            this.axios
                .post(
                    "/sys/v1/org/tree/select",
                    {
                        request: {
                            orgName: "",
                            orgType: "",
                        },
                        version: "",
                    },
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    console.log(res);
                    if (res.code == 0) {
                        this.options = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        addPlus(val) {
            if (val == 1) {
                let obj = {
                    post: null,
                    phone: '',
                    company: '',
                    organization: '',
                    resignationReason: '',
                    resignationReasonLabel: '',
                    salary: '',
                    certifier: '',
                    startTime: '',
                    endTime: ''
                }
                this.form.workRecordList.push(obj)
            } else if (val == 2) {
                let obj = {
                    educationalLevel: null,
                    educationalLevelLabel: '',
                    institutionName: '',
                    major: '',
                    educationalMode: null,
                    educationalModeLabel: '',
                    startTime: '',
                    endTime: '',
                }
                this.form.educationList.push(obj)
            } else if (val == 3) {
                let obj = {
                    name: '',
                    dateOfBirth: '',
                    company: '',
                    post: '',
                    phone: '',
                    familyRelationships: null,
                    familyRelationshipsLabel: '',
                    emergencyFlag: null
                }
                this.form.familyInfoList.push(obj)

            } else if (val == 4) {
                let obj = {
                    institutionName: '',
                    trainingContent: '',
                    trainingMode: null,
                    trainingModeLabel: '',
                    certificate: '',
                    startTime: '',
                    endTime: ''

                }
                this.form.trainingInfoList.push(obj)
            }

        },
        deletePlus(val, index) {
            if (val == 1) {
                this.form.workRecordList.splice(index, 1)
            } else if (val == 2) {
                this.form.educationList.splice(index, 1)
            } else if (val == 3) {
                this.form.familyInfoList.splice(index, 1)
            } else if (val == 4) {
                this.form.trainingInfoList.splice(index, 1)
            }

        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        handleClickAchors(tab, event) {
            console.log(tab, event);
            this.activeBtn = String(tab.index)
            let selector = 'anchor-' + String(tab.index)
            this.$refs[selector].scrollIntoView({ behavior: 'smooth' })
            this.isGo = true
            setTimeout(() => {
                //点击滚动完成
                this.isGo = false
            }, 500);
        },
    }
}
</script>
<style scoped lang="scss">
/deep/.el-date-editor{
    width: 204px;
    .el-input__inner {
        padding-left: 8px;
    }
     .el-input__prefix {
        right: 2px;
        left: auto;
        
    }
     .el-icon-circle-close {
        // right: 16px !important;
        position: absolute;
        top: 1px;
        right: 16px;
    }
}




.container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .content {
        width: 100%;
        // height: calc(100vh - 240px);
        // min-height: calc(100vh - 140px);
        margin-top: 16px;
        background-color: white;
        padding-left: 0px;
        padding-right: 0px;
        box-sizing: border-box;
        padding-top: 32px;
        border-radius: 8px 8px 0 0;

        .main1 {
            padding-top: 0;
            // height: calc(100vh - 225px);
            box-sizing: border-box;
            padding-left: 16px;
            padding-right: 16px;
             overflow-y: visible;
            .panel-block {
                // height: 100%;
                min-height: 100%;
                display: flex;

                .panel-left {
                    width: calc(100% - 225px);
                    overflow-y: auto;
                    height: 100%;

                    .panel-item {
                        .panel-item-title {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: bold;
                            font-size: 16px;
                            color: #2F3030;
                            padding-top: 32px;
                        }
                        .panel-item-title-1{
                            padding-top: 16px;
                        }
                        .panel-item-content {
                            padding-top: 24px;
                            border-top: 0;
                            height: auto;
                            
                            .form-item {
                                display: flex;
                                // justify-content: space-between;
                                flex-wrap: wrap;
                                // min-width: 600px;
                                // max-width: 100%;
                            }

                            .el-form-item {
                                // width: 290px;
                                margin-right: 30px;
                            }

                            .line {
                                width: calc(100% - 58px);
                                height: 1px;
                                background: #EDF2F2;
                                border-radius: 0px 0px 0px 0px;
                                // margin-bottom: 32px;
                                margin-top: 32px;
                            }

                            .relative {
                                width: calc(100% - 58px);
                                min-height: 67px;
                                padding: 18px 0 0 0;
                                background: #F8FAFA;
                                border-radius: 0px 0px 0px 0px;
                                display: flex;
                                justify-content: flex-start;
                                align-items: center;
                                flex-wrap: wrap;
                                 /deep/.el-form-item{
                                    margin-bottom: 16px;
                                }
                                .main-colume{
                                    flex-shrink: 0;
                                    min-height: 32px;
                                }
                                .primary-colume{
                                    // flex: 1;
                                    min-height: 32px;
                                }
                            }

                            .sort-index {
                                width: 16px;
                                height: 16px;
                                background: #E4F7F4;
                                line-height: 16px;
                                border-radius: 50%;
                                font-family: PingFang SC, PingFang SC;
                                font-weight: bold;
                                font-size: 12px;
                                color: #00B498;
                                text-align: center;
                            }

                            .sort-title {
                                font-family: PingFang SC, PingFang SC;
                                font-weight: bold;
                                font-size: 14px;
                                color: #2F3030;
                                margin-left: 2px;
                            }

                            .btn {
                                width: calc(100% - 58px);
                                height: 52px;
                                background: #FFFFFF;
                                border-radius: 0px 0px 0px 0px;
                                border: 1px solid #00B498;
                                box-sizing: border-box;
                                display: flex;
                                justify-content: center;
                                align-items: center;

                                .btn-t {
                                    font-family: PingFang SC, PingFang SC;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #00B498;
                                    margin-left: 2px;
                                    cursor: pointer;
                                }
                            }

                            .delete {
                                width: 44px;
                                height: calc(100% - 18px);
                                background: #E4F7F4;
                                border-radius: 0px 16px 16px 0px;
                                font-family: PingFang SC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #04B599;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                text-align: center;
                                position: absolute;
                                right: 16px;
                                box-sizing: border-box;
                            }
                           .connected-con{
                            display: flex;
                            line-height: 1;
                            .icon-btn{
                                width: 40px;
                                height: 32px;
                                border-radius: 0 4px 4px 0;
                                background-color: #00B498;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                font-size: 12px;
                                color: #FFF;
                                cursor: pointer;
                                
                            }
                            .dis{
                                background-color: #E3E6E5;
                                cursor: default;
                            }
                            .mini{
                                font-size: 11px;
                                line-height: 1.1;
                            }
                            /deep/{
                                .el-input{
                                    width: 164px;
                                }
                                .el-input__inner{
                                    width: 164px;
                                    border-right: none;
                                    border-radius:4px 0 0 4px;
                                }
                            }
                           } 
                        }
                    }
                }

                .panel-right {
                    padding-top: 10px;
                    position: fixed;
                    left: calc(100% - 268px);
                    /deep/{
                        .vertical-tabs {
                            .el-tabs__active-bar{
                            width: 3px!important;
                            border-radius: 3px;
                            top: 4px;
                          }
                          .el-tabs__nav-wrap::after {
                            width: 1px;
                            left: 1px;
                          }
                        }
                    }
                    .step-line {
                        position: absolute;
                        left: 6px;
                        top: 0;
                        width: 1px;
                        background: #dcdfe6;
                        height: calc(50vh - 85px);
                        z-index: 0;
                    }

                    .step-ul {
                        li {
                            padding-bottom: 20px;

                            .step-icon {
                                width: 13px;
                                height: 13px;
                                margin-right: 20px;
                                border-radius: 50%;
                                z-index: 1;
                            }

                            .step-label {
                                font-weight: 700;
                                font-size: 14px;
                                line-height: 22px;
                                color: #303133;
                            }
                        }

                        .step-active {
                            .step-icon {
                                border: 1px solid #1989fe;
                                background: #fff;
                            }

                            .step-label {
                                color: #1989fe;
                            }
                        }
                    }
                }

                ::-webkit-scrollbar {
                    width: 0 !important;
                }
            }
        }

        .main2 {
            padding-top: 16px;
            height: calc(100vh - 180px);
            box-sizing: border-box;
            padding-left: 16px;
            padding-right: 16px;

            .title {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 16px;
                color: #2F3030;
            }

            .main2-content {
                margin-top: 30px
            }
        }


    }

    .footer {
        height: 84px;
        background: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        left: 200px;
        right: 0;
        bottom: 0;
        border-top: 1px solid #EDF2F2;
        box-sizing: border-box;
      transition: left 0.3s ease-in-out ;
        z-index: 2;
        .footer-btn-b {
            width: 88px;
            height: 36px;
            background: #EDF2F2;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #939696;
            line-height: 36px;
            text-align: center;
            margin-right: 16px;
            cursor: pointer;
        }

        .footer-btn-r {
            width: 88px;
            height: 36px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #00B498;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #00B498;
            line-height: 36px;
            text-align: center;
            margin-right: 16px;
            cursor: pointer;
        }

        .footer-btn-s {
            width: 88px;
            height: 36px;
            background: #00B498;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 36px;
            text-align: center;
            cursor: pointer;
        }
    }
    .footer-collapsed{
        left: 80px;
    }

}

.dialog-body {
    .dialog-title {
        display: flex;
    }

    .dialog-line {
        width: 100%;
        height: 1px;
        background: #EDF2F2;
        border-radius: 0px 0px 0px 0px;
        margin-top: 10px;
    }

    .dialog-content {
        margin-top: 24px;

        .title-line {
            width: 2px;
            height: 16px;
            background: #00B498;
            border-radius: 0px 0px 0px 0px;
            margin-top: 8px;
        }

        .title-name {
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 16px;
            color: #2F3030;
            margin-left: 4px;
            line-height: 32px;
        }

        .dialog-main {
            .dialog-main-no {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #2F3030;
                text-align: center;
                margin-top: 38px;
                margin-bottom: 16px;
            }
        }
    }
}
.panel-item-content{

     /deep/  .el-textarea{
        .el-textarea__inner{
            padding-left: 8px;
            width:204px;
            height: 64px;
        }
        .el-input__count{
            line-height: 1;
            bottom: 6px;
        }
    }
    .dipute-textarea{
        margin-top: 1px;
        line-height: 32px;
        /deep/{
            .el-textarea__inner{
                height: 64px;
            }
            .el-input__count{
                line-height: 1;
                bottom: 6px;
                height: 18px;
            }
        }
    }
    .my-last-photo{
        display: inline-flex;
        .tips{
            margin-left: 8px;
            font-weight: 400;
            font-size: 12px;
            color: #C5C9C9;
            width: 108px;
            height:68px;
            line-height: 17px;
        }
    }
}
</style>